import classNames from 'clsx';
import { isEqual } from 'lodash';
import React from 'react';

import styles from './Decorations.scss';

export interface Props {
  showTierUp?: boolean;
  currentPoints?: number;
  targetPoints?: number;
  goingToTierDown?: boolean;
  goingToTierUp?: boolean;
  cvlConfig: { cvl2: boolean };
}

export interface State {
  animations: string[];
}

class Decorations extends React.Component<Props, State> {
  state = { animations: [] };

  animate() {
    const { currentPoints, targetPoints, showTierUp, cvlConfig, goingToTierDown, goingToTierUp } =
      this.props;
    let animations: State['animations'] = [];
    const cvl2 = cvlConfig?.cvl2;

    if (cvl2 && goingToTierDown) {
      animations = [
        classNames(styles.particles, styles.tierdown),
        classNames({ [classNames(styles.tierdown, styles.flare)]: currentPoints === targetPoints }),
        classNames(styles.beam, styles.red),
        classNames(styles.tierdown, styles.after)
      ];
    } else if ((cvl2 && goingToTierUp) || showTierUp) {
      animations = [
        classNames(styles.particles, styles.tierup),
        classNames({ [classNames(styles.tierup, styles.flare)]: currentPoints === targetPoints }),
        styles.tuImg,
        styles.beam,
        classNames(styles.tierup, styles.after)
      ];
    } else {
      animations = [
        styles.particles,
        classNames({ [styles.flare]: currentPoints === targetPoints }),
        styles.beam,
        styles.after
      ];
    }

    // remove empty classes/strings from the list (when there is no flare class)
    animations = animations.filter((a) => a.length);

    if (!isEqual(this.state.animations, animations)) {
      this.setState({
        animations
      });
    }
  }

  componentDidMount() {
    // trigger animations ot the 1st load
    this.animate();
  }

  shouldComponentUpdate(nextProps: Props, nextState: State) {
    // don't re-render the animations/component if the animations
    // have been already added in the current state
    return this.props.currentPoints !== nextProps.currentPoints || nextState.animations.length > 0;
  }

  componentDidUpdate() {
    if (!this.state.animations.length) {
      // display and replay the css animations
      this.animate();
    } else {
      // hide css animations
      this.setState({ animations: [] });
    }
  }

  render() {
    const { animations } = this.state;

    return animations.map((className, index) => <span className={className} key={index} />);
  }
}

export default Decorations;
